import {
  FETCH_LIST,
  LIST_FETCHED,
  UPDATED,
  TOGGLE_LOADING,
  SET_ACTIVE_STATE
} from './actionTypes'

export const fetchList = (params) => ({
  type: FETCH_LIST,
  payload: {
    // tenantId,
    params
  }
})

export const listFetched = result => ({
  type: LIST_FETCHED,
  payload: result
})

export const toggleLoading = () => ({
  type: TOGGLE_LOADING
})

export const updated = (id, data) => ({
  type: UPDATED,
  payload: { id, data }
})

export const setActiveState = (id, isActive) => ({
  type: SET_ACTIVE_STATE,
  payload: { id, isActive }
})
